import { useRecoilValue } from "recoil";
import useSWR from "swr";
import { soCouponDateRangeState } from "../../store/soCouponDateRangeState";

type SoCouponOverallScore = {
  overall_scores_1_count: number;
  overall_scores_1_percentage: number;
  overall_scores_2_count: number;
  overall_scores_2_percentage: number;
  overall_scores_3_count: number;
  overall_scores_3_percentage: number;
  overall_scores_4_count: number;
  overall_scores_4_percentage: number;
  overall_scores_5_count: number;
  overall_scores_5_percentage: number;
  overall_scores_average: number;
  overall_scores_count: number;
};

export const useFetchSoCouponOverallScore = (restaurantId: string) => {
  const dateRange = useRecoilValue(soCouponDateRangeState)
  const { data: soCouponOverallScore, error, isLoading } = useSWR<SoCouponOverallScore>(`socoupon/overall-score/?restaurantId=${restaurantId}&startDate=${dateRange.startDate}&endDate=${dateRange.endDate}`)
  return { soCouponOverallScore, isLoading, error };
};